export default "__VITE_ASSET__8a7438f6__"